import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { GenerationCostEvent, GenerationToastService } from '../../../services/generation-toast.service';
import { formatCredits } from '../../../shared/credit-format';

@Component({
  selector: 'app-generation-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './generation-toast.component.html',
  styleUrl: './generation-toast.component.css'
})
export class GenerationToastComponent implements OnInit, OnDestroy {
  visible = false;
  event: GenerationCostEvent | null = null;
  private timer: any;
  private sub!: Subscription;

  constructor(private toastService: GenerationToastService) {}

  ngOnInit(): void {
    this.sub = this.toastService.event$.subscribe((event) => {
      this.event = event;
      this.visible = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => { this.visible = false; }, 6000);
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    clearTimeout(this.timer);
  }

  formatCredits(value: number): string {
    return formatCredits(value);
  }

  dismiss(): void {
    this.visible = false;
  }
}
